import { LoginPageComponent } from '$pages/login/login-page.component';
import { AuthService } from '$services/auth/auth.service';
import { EventBusService } from '$services/auth/event/event-bus.service';
import { IconsService } from '$services/icons/icons.service';
import { User } from '$types';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '$environments/environment'
import { HttpClient } from '@angular/common/http'

@Component({
  selector: 'app-menu-desktop',
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.css']
})
export class MenuDesktopComponent implements OnInit {
  cgvUrl = '/assets/docs/petites_annonces_SECF_CGU_v_Def.pdf'
  user: User | null;

  constructor(
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly authService: AuthService,
    private readonly icons: IconsService,
    private readonly eventBusService:EventBusService,
    private readonly http: HttpClient
  ) {
    this.icons.registerIcon([`filter`, `file-plus`])

    this.user = this.authService.user;
  }
  ngOnInit(): void {
    this.eventBusService.on(
      'login', (action: any)=>{
        this.user = this.authService.user;
      }
    )
  }

  tryOpenCreation() {
    if (this.notLogged()) {
      this.showLoginScreen().subscribe((x) => {

        switch (x) {
          case 'login':
            this.tryOpenCreation()
            break;
          case 'cancel':
            console.log('cancel login')
            break;
          default:
            console.log('what ?')
            break;
        }

      })
    } else {
      this.showCreationScreen()
    }
  }
  showCreationScreen() {
    this.router.navigate(['/posts/create'])
  }
  notLogged(): boolean {
    return !this.authService.isLogged()
  }
  showLoginScreen(): Observable<string> {
    return this.dialog
      .open(LoginPageComponent, {
        panelClass: 'login-modalbox'
      })
      .afterClosed()
  }
  getAddPostClassname(user: User | null): string {

    if (!user?.id) {
      return 'actions__create'
    }

    return user?.moderator ? 'actions__create-mod' : 'actions__create'
  }

  exportToExcel() {
    const apiUrl = environment.apiUrl + '/rest/transactions/export';
    this.http.get(apiUrl, {responseType: 'blob'}).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'transactions.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error: any) => {
        console.error('Export failed', error);
      }
    );
  }


}
